export const MAX_SN_COUNT_FOR_SINGLE_SN_CALLS = 20;
export const DELAY_BETWEEN_SINGLE_SN_CALLS = 50;
